import React from 'react'

import { Key as Component } from './Key'

const Key = (props) => {
  return <Component {...props}/>
}
export default Key
